import { render } from "./AppLayoutMain.vue?vue&type=template&id=3d3b1d30"
import script from "./AppLayoutMain.vue?vue&type=script&lang=js"
export * from "./AppLayoutMain.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3d3b1d30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d3b1d30', script)) {
    api.reload('3d3b1d30', script)
  }
  
  module.hot.accept("./AppLayoutMain.vue?vue&type=template&id=3d3b1d30", () => {
    api.rerender('3d3b1d30', render)
  })

}

script.__file = "resources/js/Layouts/AppLayoutMain.vue"

export default script